module.exports = __webpack_public_path__ + "static/media/QS.58d77ea5.svg";